import React, { useEffect, useState, useRef } from "react";
import "../styles/ReadingInside.css";
import Question from "./layout/Question";
import { motion } from "framer-motion";
import { useParams, Link } from "react-router-dom";
import jsPDF from "jspdf";
import parse from "html-react-parser";



const containerVariants = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  hiddenRight: {
    opacity: 0,
    x: "-100vh",
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 120,
    },
  },
};

const ReadingInside = () => {
  const [readIn, setReadIn] = useState([]);
  const [loading, setLoading] = useState(true);
  const [UNP, setUNP] = useState(false);
  const [logFirst,setLogFirst] = useState(false)

  // const history = useHistory()

  const { _id } = useParams();
  const pdfRef = useRef(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/read/${_id}`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log("data",data)
        if (data.status === "success") {
          setLoading(false);
          setReadIn(data.msg);
          setUNP(false);
        }else if(data.msg === "Login first"){
          setLogFirst(true)
          setLoading(false);
          // window.location.href = "/login"
          // history.push("/login")
        }
         else {
          setLoading(false);
          setUNP(true);
          
          // console.clear();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [_id]);

  const handleDownload = () => {
    const content = pdfRef.current;
    const doc = new jsPDF();
    doc.html(content, {
      callback: function (doc) {
        doc.save("sample.pdf");
      },
      html2canvas: { scale: 0.1 }, // change the scale to whatever number you need
    });
  };

  if (loading) {
    return (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    );
  } 
  else if (logFirst) {
    return (
      <div className="not-Premium">
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-11 m-auto">
              <h3 className="text-center text-not-Premium">
              Sorry, Please Login First.
              </h3>
              <div className="text-center mt-4">
                <Link to="/login" className="btn btn-premium">
                  Go to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  else if (UNP) {
    return (
      <div className="not-Premium">
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-11 m-auto">
              <h3 className="text-center text-not-Premium">
                Sorry, you are not premium user. Please upgrade your account to.
              </h3>
              <div className="text-center mt-4">
                <Link to="/pricing" className="btn btn-premium">
                  Go to Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ReadingInside" id="content" ref={pdfRef}>
      <div className="container">
        <div className="row">
          <motion.div
            className="col-lg-7 ReadingInside-left"
            variants={containerVariants}
            initial="hiddenRight"
            animate="visible"
          >
            <h2>{readIn.title}</h2>

            <div className="ReadingInside-content">
              {parse(readIn.description)}
            </div>
          </motion.div>

          <motion.div
            className="col-lg-5 ReadingInside-right"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <div className="ReadingInside-right-button">
              <motion.button
                className="contBut-med-width"
                whileHover={{ scale: 1.05, boxShadow: " 0 0 8px #1A2D40" }}
                onClick={handleDownload}
              >
                Download Pdf
              </motion.button>
            </div>
            {readIn.quizzes?.map((item, index) => (
              <Question
                item={item}
                hasIndex={index}
                index={index}
                key={index}
              />
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ReadingInside;
